export const calculateAge = (dob: string) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
  
    // If today's month is before the birth month, or it's the same month but the current day is before the birth day, reduce the age by 1
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
  
    return age;
  };

  export const formatDate = (dateString: string) => {
    const appointmentDate = new Date(dateString);

    return new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(appointmentDate);
  };

  export function formatTime(dateTime: string): string {
    const datetime = new Date(dateTime);

    const timeOptions: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, 
    };

    const formattedTime = datetime.toLocaleString("en-US", timeOptions);

    return formattedTime;
}


  export const formatTimeWithTimeZone = (date: Date) => {
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "America/New_York", // Example for Eastern Time (ET), adjust as per your needs
    }).format(date);
  };

export const handleNavigate = (url:string)=>{
  //use this where need to reload page 
  window.location.href = url;
}


  